import CryptoJS from 'crypto-js';
const encryptKey = 'ewfWE@#%$rfdsefgdsfa';
export const encryptText = (text: any) => {
  const ciphertext = CryptoJS.AES.encrypt(text, encryptKey).toString();
  return ciphertext;
};
export const decryptText = (text: any) => {
  const bytes = CryptoJS.AES.decrypt(text, encryptKey);
  const originalText = bytes.toString(CryptoJS.enc.Utf8);
  return originalText;
};
